module.exports = __webpack_public_path__ + "img/41.8e640a8a.png";